// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"132":"dd7200878008e5b35e11","288":"c8294f57e39d47f923e8"}[chunkId] + ".bundle.js";
};